export const FORM_OF_EDUCATION_FULL_TIME = "Full-time (On-campus)";
export const FORM_OF_EDUCATION_DISTANCE = "Distance (online)";

export const FORM_OF_EDUCATION_OPTIONS = [
  { value: FORM_OF_EDUCATION_FULL_TIME, label: FORM_OF_EDUCATION_FULL_TIME },
  { value: FORM_OF_EDUCATION_DISTANCE, label: FORM_OF_EDUCATION_DISTANCE },
] as const;

export const MALTA_FORM_OF_EDUCATION_LABELS = FORM_OF_EDUCATION_OPTIONS.map(({ label }) => label);

const FORM_OF_EDUCATION_ALIASES: Record<string, string> = {
  [FORM_OF_EDUCATION_FULL_TIME.toLowerCase()]: FORM_OF_EDUCATION_FULL_TIME,
  [FORM_OF_EDUCATION_DISTANCE.toLowerCase()]: FORM_OF_EDUCATION_DISTANCE,
  "on-campus": FORM_OF_EDUCATION_FULL_TIME,
  "on campus": FORM_OF_EDUCATION_FULL_TIME,
  "full-time": FORM_OF_EDUCATION_FULL_TIME,
  "full time": FORM_OF_EDUCATION_FULL_TIME,
  online: FORM_OF_EDUCATION_DISTANCE,
  distance: FORM_OF_EDUCATION_DISTANCE,
  "part-time": FORM_OF_EDUCATION_DISTANCE,
  "part time": FORM_OF_EDUCATION_DISTANCE,
};

export const normalizeFormOfEducationValue = (value?: unknown): string => {
  if (value == null) return "";
  const trimmed = String(value).trim();
  if (!trimmed) return "";

  if (FORM_OF_EDUCATION_OPTIONS.some((option) => option.label === trimmed || option.value === trimmed)) {
    return trimmed;
  }

  const aliasMatch = FORM_OF_EDUCATION_ALIASES[trimmed.toLowerCase()];
  if (aliasMatch) {
    return aliasMatch;
  }

  const lower = trimmed.toLowerCase();
  if (
    lower.includes("distance") ||
    lower.includes("online") ||
    lower.includes("part-time") ||
    lower.includes("part time")
  ) {
    return FORM_OF_EDUCATION_DISTANCE;
  }

  if (
    lower.includes("full-time") ||
    lower.includes("full time") ||
    lower.includes("on-campus") ||
    lower.includes("on campus")
  ) {
    return FORM_OF_EDUCATION_FULL_TIME;
  }

  return trimmed;
};

export const resolveFormOfEducationValue = normalizeFormOfEducationValue;
